import React from 'react';
import { errorKey, errorsWithoutContextAndFields } from '@/utils/errors';
import ErrorMessage from './ErrorMessage';

const ErrorMessages = ({
  category,
  code,
  contexts,
  entity,
  errors,
  onDismiss,
}) => (
  (errors || []).map((error) => (
    <ErrorMessage
      className={`${entity}-error-message`}
      error={error}
      key={errorKey(error, contexts, ['error_message', entity], [category, code])}
      onDismiss={onDismiss ? () => onDismiss(errorsWithoutContextAndFields(errors, error)) : undefined}
    />
  ))
);

export default ErrorMessages;
